export default "__VITE_ASSET__Dn9x4UyE__"